module.exports = __webpack_public_path__ + "media/05 commemorate.aaedcd9f.mp3";